import { Component } from 'react';

import { Link } from '@zola/zola-ui/src/components/Link';
import { formatArrayWithOxfordComma } from '@zola-helpers/client/dist/es/transformers/formatArrayWithOxfordComma';

import cx from 'classnames';
import PropTypes from 'prop-types';

import featureFlags from '@/util/featureFlags';

import {
  formatExpShippingDate,
  deliverySurchargeCopy,
  returnHolidayShippingMessage,
} from './helpers';
import gift from '../../assets/images/icons/gift.svg';
import { formatPrice } from '../../util/currencyFormatter';
import './Accordion.less';

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.toggleItem = this.toggleItem.bind(this);
    this.state = {
      selectedItems: [],
    };
  }

  isShippingZonesV2 = () => {
    if (typeof window === 'undefined') return false;
    return featureFlags.get('shippingZonesV2');
  };

  toggleItem(id) {
    const { allowMultiple } = this.props;

    if (allowMultiple) {
      this.setState((state) => {
        const isOpen = state.selectedItems.indexOf(id) >= 0;
        const updatedItems = isOpen
          ? state.selectedItems.filter((i) => i !== id)
          : [...state.selectedItems, id];
        return { selectedItems: updatedItems };
      });
    } else {
      this.setState((state) => {
        const isOpen = state.selectedItems.indexOf(id) >= 0;
        const updatedItems = isOpen ? [] : [id];
        return { selectedItems: updatedItems };
      });
    }
  }

  render() {
    const { items, className, activeSku } = this.props;
    const { selectedItems } = this.state;
    const classes = cx('marketplace__accordion', className);

    const renderHolidayShipping = (productData, freeShippingMin, expShippingMax) => {
      const holidayShippingMessage = returnHolidayShippingMessage(
        productData,
        freeShippingMin,
        expShippingMax,
        activeSku
      );

      return holidayShippingMessage ? (
        <div className="shipping-text">
          <span className="holiday-arrival-question">
            <img src={gift} alt="" className="holiday-arrival-question__icon" /> Want it by 12/24?
          </span>
          <span className="shipping-text holiday-arrival-suggestion">{` ${holidayShippingMessage}`}</span>
        </div>
      ) : null;
    };

    return (
      <div className={classes}>
        {items &&
          items.map((item) => (
            <div
              className={`accordion__section ${
                selectedItems.indexOf(item.id) >= 0 ? 'selected' : ''
              }`}
              key={item.id}
            >
              <button
                onClick={() => this.toggleItem(item.id)}
                type="button"
                className="accordion__button"
              >
                <span className="accordion__section-heading">{item.heading}</span>
                <i
                  className={`accordion__chevron ${
                    selectedItems.indexOf(item.id) >= 0
                      ? 'zola-ui-icon-chevron-up'
                      : 'zola-ui-icon-chevron-down'
                  }`}
                />
              </button>
              <div className="accordion__body-container">
                {item.type === 'description' ? (
                  // eslint-disable-next-line
                  <div
                    className="product-description"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                ) : null}
                {item.type === 'details' ? (
                  <>
                    {item.details.map((detail) => (
                      <div key={detail.label}>
                        {detail.label}: {detail.value}
                      </div>
                    ))}
                    <div>
                      Brand:{' '}
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`/shop/brand/${item.brand.key}`}
                      >
                        {item.brand.name}
                      </Link>
                    </div>
                  </>
                ) : null}
                {item.type === 'arrival' ? (
                  <>
                    <div className="shipping-text arrival">Estimated Arrival</div>
                    <div className="shipping-text">
                      {item.shippingText}: {item.shipDates.freeShippingMin} -{' '}
                      {item.shipDates.freeShippingMax}
                    </div>
                    {item.shipDates.expShippingMax && item.shipDates.expShippingMin ? (
                      <div className="shipping-text">
                        {formatExpShippingDate(
                          item.shipDates.expShippingMin,
                          item.shipDates.expShippingMax
                        )}
                      </div>
                    ) : null}
                    {renderHolidayShipping(
                      item.productData,
                      item.shipDates.freeShippingMin,
                      item.shipDates.expShippingMax
                    )}
                    {item.deliverySurcharge ? (
                      <div className="shipping-text">{item.customShippingMessage}</div>
                    ) : null}
                  </>
                ) : null}
                {item.type === 'shipping' ? (
                  <>
                    {item.deliverySurcharge ? (
                      <div className="shipping-method-text">
                        {deliverySurchargeCopy} {formatPrice(item.deliverySurcharge)}
                      </div>
                    ) : null}
                    <div className="shipping-method-text">Shipping Method: {item.shipMethod}</div>
                    <div className="return-policy-text">
                      Return Policy: {item.returnPolicy}
                      <Link arrow target="_blank" rel="noopener noreferrer" href="/returns">
                        See details
                      </Link>
                    </div>
                    {!this.isShippingZonesV2() &&
                    item.shipMethod !== 'E-delivery' &&
                    item.shippingZones.indexOf('US_ALASKA_AND_HAWAII') === -1 ? (
                      <div className="shipping-exclusion-text">
                        <span>Please note this gift cannot be shipped to Alaska or Hawaii. </span>
                        <Link
                          arrow
                          href="/faq/360000894232-do-you-ship-to-alaska-and-hawaii-"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Find out why
                        </Link>
                      </div>
                    ) : null}
                    {this.isShippingZonesV2() &&
                    item.shipMethod !== 'E-delivery' &&
                    item.shippingExcludedStates.length > 0 ? (
                      <div className="shipping-exclusion-text">
                        <span>
                          Please note this gift cannot be shipped to{' '}
                          {formatArrayWithOxfordComma(item.shippingExcludedStates, 'or')}.{' '}
                        </span>
                        <Link
                          arrow
                          href="/faq/where-can-zola-products-be-shipped"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Find out why
                        </Link>
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
          ))}
      </div>
    );
  }
}

Accordion.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  allowMultiple: PropTypes.bool,
  activeSku: PropTypes.shape({}),
};

Accordion.defaultProps = {
  allowMultiple: false,
};

export default Accordion;
